<div class="modal-header">
  <h4 class="modal-title pull-left">Report Note</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-sm-12">
      <label class="rbv-label">Note</label>
      <textarea class="form-control rounded-0" rows="3" name="CONTENT" [(ngModel)]="reportNote.CONTENT"></textarea>
    </div>
  </div>
</div>

<div class="modal-footer">

  <div class="footer-wrapper">
    <div class="checkbox-item">
      <input class="checkbox-custom" type='checkbox' name="CLIENT_VISIBLE" id="CLIENT_VISIBLE" [(ngModel)]="reportNote.CLIENT_VISIBLE" />
      <label class="checkbox-custom-label" for="CLIENT_VISIBLE">
        Visible to Client
      </label>
    </div>

    <div class="actions">
      <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
      <button class="btn btn-rbv" [disabled]="!reportNote.CONTENT" (click)="onConfirm()">Save</button>
    </div>
  </div>
</div>
